import { render, staticRenderFns } from "./CustomDate.vue?vue&type=template&id=5fceebf2&scoped=true"
import script from "./CustomDate.vue?vue&type=script&lang=js"
export * from "./CustomDate.vue?vue&type=script&lang=js"
import style0 from "./CustomDate.vue?vue&type=style&index=0&id=5fceebf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fceebf2",
  null
  
)

export default component.exports